var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[_vm.$style.container, ( _obj = {}, _obj[_vm.$style.indicator] = _vm.showIndicators, _obj )],attrs:{"id":"hud-talent-tree"}},[_c('talent-tooltip',{attrs:{"position":"top","hero":_vm.hero,"withAttributes":true}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }